module.exports = __webpack_public_path__ + "img/experience.ecc69559.jpg";